<template>
  <Modal :id="'cmp-send-doc-files'" @cancelled="onCancel">
    <template slot="header">{{
      sendDocumentFilesData.document_send_title
    }}</template>

    <template slot="body">
      <div class="document-file-invoice-container" style="min-height: 200px">
        <table
          class="dt-table2 documents-table cp"
          v-if="
            sendDocumentFilesData &&
            sendDocumentFilesData.documents &&
            sendDocumentFilesData.documents.length > 0
          "
        >
          <thead class="dt-table2--head">
            <tr
              class="dt-table2--row"
              :style="{
                'margin-right': hRowMarginRight,
              }"
            >
              <th class="dt-table2--column table-title">{{$t('document')}}</th>
              <th class="dt-table2--column"></th>
              <th class="dt-table2--column"></th>
              <th class="dt-table2--column"></th>
            </tr>
          </thead>
          <tbody class="dt-table2--body">
            <tr
              class="dt-table2--row"
              v-for="(document, index) in sendDocumentFilesData.documents"
              :key="index"
            >
              <td class="dt-table2--column">
                {{ document["booking_template_name"] }}
              </td>
              <td class="dt-table2--column">{{ document["subject"] }}</td>
              <td class="dt-table2--column">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    @click="(e) => onDocumentSelected(e, document)"
                    :name="document.document_id"
                    :id="document.document_id"
                    :checked="selectedDocuments.has(document.document_id)"
                  />
                  <div class="checkmark"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table
          class="dt-table2 invoices-table cp"
          v-if="
            sendDocumentFilesData &&
            sendDocumentFilesData.invoices &&
            sendDocumentFilesData.invoices.length > 0
          "
        >
          <thead class="dt-table2--head">
            <tr
              class="dt-table2--row"
              :style="{
                'margin-right': hRowMarginRight,
              }"
            >
              <th class="dt-table2--column table-title">{{$t('invoice_no')}}</th>
              <th class="dt-table2--column">{{$t('payee')}}</th>
              <th class="dt-table2--column date">{{$t('date')}}</th>
              <th class="dt-table2--column">{{$t('recipient')}}</th>
              <th class="dt-table2--column desc">{{$t('description')}}</th>
              <th class="dt-table2--column amount">{{$t('amount')}}</th>
              <th class="dt-table2--column enable-paypal">{{$t('enable_paypal')}}</th>
              <th class="dt-table2--column checkbox-column">&nbsp;</th>
            </tr>
          </thead>
          <tbody class="dt-table2--body">
            <tr
              class="dt-table2--row"
              v-for="invoice in sendDocumentFilesData.invoices"
              :key="invoice.invoice_id"
            >
              <td class="dt-table2--column">{{ invoice["invoice_ref"] }}</td>
              <td class="dt-table2--column flex-wrap">
                {{ invoice["invoice_project_name"] }}
              </td>
              <td class="dt-table2--column date">
                {{ invoice["invoice_date"] }}
              </td>
              <td class="dt-table2--column">{{ invoice["company_name"] }}</td>
              <td class="dt-table2--column flex-wrap desc">
                {{ invoice["subject"] }}
              </td>
              <td class="dt-table2--column amount">
                {{ invoice["gross_amount_cc"] + " " + invoice["currency_iso"] }}
              </td>
              <td
                class="dt-table2--column enable-paypal"
                :title="
                  isPaypalCheckboxdisabled(invoice)
                    ? $t('invoice_project_doesnt_have_paypal')
                    : $t('click_to_enable_paypal')
                "
              >
                <div
                  class="dt-checkbox v2 s1"
                  :class="{
                    disabled: isPaypalCheckboxdisabled(invoice),
                  }"
                >
                  <input
                    type="checkbox"
                    :disabled="isPaypalCheckboxdisabled(invoice)"
                    :name="invoice.invoice_id"
                    :id="invoice.invoice_id"
                    :checked="
                      invoice['paypal_email'] &&
                      invoice['paypal_email'].length > 0
                    "
                    @click="(e) => onPaypalEnabled(e, invoice)"
                  />
                  <div class="checkmark"></div>
                </div>
              </td>
              <td class="dt-table2--column checkbox-column">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    @click="(e) => onInvoiceSelected(e, invoice)"
                    :name="invoice.invoice_id"
                    :id="invoice.invoice_id"
                    :checked="selectedInvoices.has(invoice.invoice_id)"
                  />
                  <div class="checkmark"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table
          v-if="
            sendDocumentFilesData &&
            sendDocumentFilesData.files &&
            sendDocumentFilesData.files.length > 0
          "
          class="dt-table2 files-table cp"
        >
          <thead class="dt-table2--head">
            <tr
              class="dt-table2--row"
              :style="{
                'margin-right': hRowMarginRight,
              }"
            >
              <th class="dt-table2--column table-title">{{$t('related_documents')}}</th>
            </tr>
          </thead>
          <tbody class="dt-table2--body">
            <tr
              class="dt-table2--row"
              v-for="file in sendDocumentFilesData.files"
              :key="file.file_id"
            >
              <td class="dt-table2--column">{{ file["file_description"] }}</td>
              <td class="dt-table2--column">{{ file["file_name"] }}</td>
              <td class="dt-table2--column">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    @click="(e) => onFileSelected(e, file)"
                    :name="file.file_id"
                    :id="file.file_id"
                    :checked="selectedFiles.has(file.file_id)"
                  />
                  <div class="checkmark"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <v-dialog v-model="enableOAFlag" width="562">
        <EnableOnlineAgreement
          :documents="enableOADocuments"
          @enableOA="onEnableOA"
          @displayOnly="onDisplayOnly"
          @cancelled="cancelOA"
        />
      </v-dialog>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
      <button
        :disabled="!sendDocumentFileButtonVisibility"
        :class="{
          disabled: !sendDocumentFileButtonVisibility,
        }"
        class="dt-button v1 s6"
        style="max-width: 185px"
        @click="onSendDocumentsFiles"
      >
        {{$t('send_document_and_files')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace,
} from "../store";
import * as ActionTypes from "../store/types";

import { mapGetters, mapActions } from "vuex";

import DetailsTable from "../../../plugins/datatable/datatable";
import InputField from "../../../plugins/text-field/input-field";

import Modal from "../../../dt-plugins/modal/modal";
import { addRemoveSet, sendMail, waitForAnimation } from "../../../utility";

import { BookingService } from "../services/booking-service";

import {
  bookingDocumentService,
  DocumentsService,
} from "../services/booking-details/documents.service";
// import {  }

import EnableOnlineAgreement from "./enable-online-agreement.vue";
import { NotificationService } from "../../../dt-plugins/notification/notification.service";
import { openModalRoute } from "../../../dt-plugins/modal/modal.mixin";

export default {
  components: {
    DetailsTable,
    InputField,
    Modal,

    EnableOnlineAgreement,
  },
  data: function () {
    return {
      sendDocumentFilesData: {
        calendar_date_id: "",
        contact_id_promoter: "",
        document_send_title: "",
        documents: [],
        files: [],
        invoices: [],
      },

      selectedDocuments: new Set(),
      selectedInvoices: new Set(),
      selectedFiles: new Set(),

      enableOAFlag: false,
      enableOADocuments: [],
    };
  },
  mounted: async function () {
    if (parseInt(this.calendarDateId) > 0) {
      this.sendDocumentFilesData = await BookingService.findSendDocumentFiles(
        this.calendarDateId
      );
      console.log({ "this.sendDocumentFilesData": this.sendDocumentFilesData });
    } else {
      throw Error("Calendar Date Id is not valid");
    }

    if (!this.calendarDateId) {
      throw Error(
        "Pass in a Valid Calendar Date id in the Query or the Parameter of the Route"
      );
    }
  },
  computed: {
    hRowMarginRight: function () {
      if (false) {
        return "28px";
      }
    },
    sendDocumentFileButtonVisibility() {
      return (
        this.selectedDocuments.size > 0 ||
        this.selectedInvoices.size > 0 ||
        this.selectedFiles.size > 0
      );
    },
    calendarDateId() {
      return (
        this.$route.params.calendar_date_id ||
        this.$route.query.calendar_date_id
      );
    },
    selectedDocumentList() {
      return Array.from(this.selectedDocuments);
    },
    selectedInvoiceList() {
      return Array.from(this.selectedInvoices);
    },
    selectedFileList() {
      return Array.from(this.selectedFiles);
    },
  },
  methods: {
    onSendDocumentsFiles: async function (e) {
      // this[ActionTypes.INSERT_SEND_DOCUMENT_FILES_DATA]();
      const selectedDocumentList = this.selectedDocumentList.map((docId) =>
        this.sendDocumentFilesData.documents.find(
          (doc) => doc.document_id == docId
        )
      );
      console.log(selectedDocumentList);

      const unsignedDocuments = selectedDocumentList.filter(
        (e) => !e.signed_documents_id
      );
      console.log({ unsignedDocuments });
      if (unsignedDocuments.length > 0) {
        this.enableOADocuments = unsignedDocuments;
        this.enableOAFlag = true;
        return;
      } else {
        this.openSendDocMail();
      }

      // const insertedSendDocumentFiles =
      //   await BookingService.insertSendDocumentFiles(
      //     calendarDateId,
      //     selectedDocuments,
      //     selectedInvoices,
      //     selectedFiles
      //   ).then((res) => res.data);

      // console.log("SSSSSS", insertedSendDocumentFiles);
      // //       {
      // //   "body": " --------- FILES --------- \n\n00.PNG (english 1) \nhttps://details.to/short/3c5697160ab6a3560541966e474fad4e \n\n026297990794.jpg (Audio Salad File of 026297990794) \nhttps://details.to/short/b83bc7093035de257a0720f1d7f04f7f \n\n",
      // //   "to": "safiqul@berlin3.com,emg1@gmail.com",
      // //   "mail_subject": "2020-08-20 - Mirpur Stadium, Dhaka, Bangladesh - Safiqul à¦°à¦¾à¦œà§€à¦¬"
      // // }
      // this.$emit("openEmailModal", insertedSendDocumentFiles);
      // const { body, to, mail_subject } = insertedSendDocumentFiles;
      // let document =
      //   "---------Douments------------\n" + insertedSendDocumentFiles.documents;
      // let file =
      //   "------------Files-----------------\n" +
      //   insertedSendDocumentFiles.files;

      // sendMail({
      //   subject: mail_subject,
      //   body:body2,
      //   mails: to.split(","),
      //   to
      // });

      // this.$emit("cancelled", true);
      // this.selectedDocuments = new Set();
      // this.selectedInvoices = new Set();
      // this.selectedFiles = new Set();
    },
    onCancel: function (e) {
      this.$emit("cancelled", true);
    },
    onDocumentSelected: function (e, item) {
      // if (e.target.checked) {
      //   this.selectedDocuments.add(item.document_id);
      // } else {
      //   this.selectedDocuments.delete(item.document_id);
      // }

      this.selectedDocuments = addRemoveSet(
        e.target.checked,
        this.selectedDocuments,
        item.document_id
      );
    },
    onInvoiceSelected: function (e, item) {
      this.selectedInvoices = addRemoveSet(
        e.target.checked,
        this.selectedInvoices,
        item.invoice_id
      );
    },
    onPaypalEnabled: async function (e, invoice) {
      const enabled = e.target.checked;
      const { invoice_id } = invoice;
      this.sendDocumentFilesData = {
        ...this.sendDocumentFilesData,
        invoices: this.sendDocumentFilesData.invoices.map((inv) => {
          if (inv.invoice_id == invoice.invoice_id) {
            return {
              ...inv,
              paypal_email: enabled ? inv.invioce_project_email_address : "",
            };
          } else {
            return inv;
          }
        }),
      };
      await bookingDocumentService.addRemovePayPal(
        invoice_id,
        enabled ? "1" : "0"
      );
      NotificationService.showNotification({
        text: "Paypal Payment option updated",
        timeout: 5000,
      });
    },
    onFileSelected: function (e, item) {
      // if (e.target.checked) {
      //   this.selectedFiles.add(item.file_id);
      // } else {
      //   this.selectedFiles.delete(item.file_id);
      // }
      this.selectedFiles = addRemoveSet(
        e.target.checked,
        this.selectedFiles,
        item.file_id
      );
    },
    cancelOA() {
      this.enableOAFlag = false;
      waitForAnimation(() => {
        this.enableOADocuments = [];
      });
    },
    async onEnableOA() {
      await Promise.all(
        this.enableOADocuments.map((doc) =>
          bookingDocumentService.generateSignedDocPromoterAgreement(
            this.calendarDateId,
            doc.document_id
          )
        )
      );
      this.cancelOA();
      this.openSendDocMail();
    },
    async onDisplayOnly() {
      await Promise.all(
        this.enableOADocuments.map((doc) =>
          bookingDocumentService.generateSignedDocPromoterView(
            doc.document_id,
            this.sendDocumentFilesData.contact_id_promoter
          )
        )
      );
      this.cancelOA();
      this.openSendDocMail();
    },
    async openSendDocMail() {
      console.log({
        calendarDateId: this.calendarDateId,
        selectedDocumentList: this.selectedDocumentList,
        selectedInvoiceList: this.selectedInvoiceList,
        selectedFileList: this.selectedFileList,
      });
      const insertedSendDocumentFiles =
        await BookingService.insertSendDocumentFiles(
          this.calendarDateId,
          this.selectedDocumentList,
          this.selectedInvoiceList,
          this.selectedFileList
        ).then((res) => res.data);

      openModalRoute(this, "choose_mail_template", {
        type: "document_and_files",
        calendar_date_id: this.$route.params.calendar_date_id
          ? undefined
          : this.calendar_date_id,
        document_id:
          this.selectedDocumentList?.length > 0
            ? this.selectedDocumentList.join(",")
            : undefined,
        invoice_id:
          this.selectedInvoiceList?.length > 0
            ? this.selectedInvoiceList.join(",")
            : undefined,
        file_relation_id:
          this.selectedFileList?.length > 0
            ? this.selectedFileList.join(",")
            : undefined,
      });

      // this.$emit("openEmailModal", insertedSendDocumentFiles);
    },
    isPaypalCheckboxdisabled(invoice) {
      console.log({ invoice: invoice });
      return (
        invoice["invioce_project_email_address"] == null ||
        invoice["invioce_project_email_address"] == ""
      );
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  tbody {
    padding-bottom: 0px;
    tr:last-child {
      border-bottom: none;
    }
  }
}

.no-white-space {
  overflow: inherit;
  white-space: inherit;
}

.document-file-invoice-container {
  display: flex;
  flex-direction: column;

  .dt-table2 {
    --body-height: 100% !important;
    --row-margin-header: 0px;
    margin: 15px 0px;

    &.invoices-table {
      tr {
        margin-left: 0;
        margin-right: 0;
        th,
        td {
          padding-right: 5px;
          &.date {
            max-width: 80px;
          }
          &.amount {
            max-width: 120px;
          }
          &.desc {
            flex: 2;
            padding-left: 15px;
            padding-right: 15px;
          }
          &.enable-paypal {
            max-width: 90px;
            text-align: right;
            padding-right: 0;
          }
          &.checkbox-column {
            max-width: 50px;
            padding-right: 0;
            .dt-checkbox {
              margin-right: 15px;
            }
          }
        }
      }
    }

    tr {
      margin-left: 0;
      margin-right: 0;
    }

    td {
      &.dt-table2--column {
        &:last-child,
        &.flex-end {
          // display: flex;
          // justify-content: flex-end;

          .dt-checkbox {
            margin-right: 15px;
          }
        }

        &.flex-wrap {
          @extend .no-white-space;
        }
      }
    }
  }

  th.table-title {
    font-weight: 500;
    color: var(--text-accent);
  }
}
</style>
